export default __webpack_public_path__ + "static/media/objetivos_ENG_.f40f6799.png";